import { Injectable } from '@angular/core'
import { ValidatorFn, AsyncValidatorFn, FormControl, AbstractControl } from '@angular/forms'

import { IAppHttp } from 'core/http/i-app-http'
import { MaxLengthValidator } from './validators/max-length.validator'
import { MaxValidator } from './validators/max.validator'
import { MinLengthValidator } from './validators/min-length.validator'
import { minValidator } from './validators/min.validator'
import { PatternValidator } from './validators/pattern.validator'
import { PeriodValidator } from './validators/period.validator'
import { RemoteValidator } from './validators/remote.validator'
import { RequiredValidator } from './validators/required.validator'
import { minArrayLengthValidator } from './validators/min-array-length.validator'
import { maxFormArrayLengthValidator } from './validators/max-form-array-length.validator'
import { ValuesMatchValidator } from './validators/values-match.validator'
import { SlotSizeValidator } from './validators/slot-size.validator'

@Injectable()
export class ValidatorsService {
  constructor(private httpService: IAppHttp) {}

  max(max: number): ValidatorFn {
    return new MaxValidator(max).validate
  }

  min(min: number, message: string = ""): ValidatorFn {
    return minValidator(min, message)
  }

  maxLength(maxLength: number): ValidatorFn {
    return new MaxLengthValidator(maxLength).validate
  }

  minLength(minLength: number): ValidatorFn {
    return new MinLengthValidator(minLength).validate
  }

  pattern(regexp: RegExp): ValidatorFn {
    return new PatternValidator(regexp).validate
  }

  period(from: string, to: string, format: string = null) {
    return new PeriodValidator(from, to, format).validate
  }

  slotSize(from, to, size) {
    return new SlotSizeValidator(from, to, size).validate
  }

  valuesMatch(control: AbstractControl): ValidatorFn {
    return new ValuesMatchValidator(control).validate
  }

  remote(
    url: string,
    errorKey: string,
    requestData: Object = {},
    minValueLength: number = 1,
    debounceTime: number = 600
  ): AsyncValidatorFn {
    return new RemoteValidator(this.httpService, url, errorKey, requestData, minValueLength, debounceTime).validate
  }

  required(message: string = ""): ValidatorFn {
    return new RequiredValidator(message).validate
  }

  maxFormArrayLength(maxLength: number, message: string = ""): ValidatorFn {
    return maxFormArrayLengthValidator(maxLength, message)
  }

  minArrayLength(minLength: number): ValidatorFn {
    return minArrayLengthValidator(minLength)
  }

  multiSelectMinLength(minLength: number, message: string = ""): ValidatorFn {
    return (control: FormControl) => {
      const length = control.value.length
      if (length == 0 || length >= minLength) {
        return null
      } else {
        if (message.length == 0) {
          message = `Минимальная длинна: ${minLength}`
        } else {
          message = message
            .replace("{minLength}", minLength.toString())
            .replace("{length}", length.toString())
        }
        return { 
          multiSelectMinLength: { minLength, length, message }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/core/forms/validators.service.ts